"use client";

import React from "react";

import { cn } from "utils";

export interface ScoreRankCellProps {
  score: number;
  rankLabel: string;
  /** 排名主数字使用绿色 rank 样式 */
  rankStyle?: "brand" | "rankGreen";
  /**
   * stacked：主分在上、rankLabel 在下（对比表总分 + 2/100）
   * inlineRank：主分与 rankLabel 同一行（如 2 与 /100，多资产综合排名列）
   */
  layout?: "stacked" | "inlineRank";
  className?: string;
}

export const ScoreRankCell: React.FC<ScoreRankCellProps> = ({
  score,
  rankLabel,
  rankStyle = "brand",
  layout = "stacked",
  className,
}) => {
  const scoreClass = cn(
    rankStyle === "rankGreen"
      ? "title_l text-content_accent1_primary"
      : "button_l text-content_brand_primary",
  );

  if (layout === "inlineRank") {
    return (
      <div
        className={cn(
          "flex items-baseline justify-center gap-0 whitespace-nowrap leading-none",
          className,
        )}
      >
        <span className={scoreClass}>{score}</span>
        <span className="body_m text-content_quaternary">{rankLabel}</span>
      </div>
    );
  }

  return (
    <div className={cn("flex flex-col items-center gap-0.5", className)}>
      <div className="flex items-center leading-none">
        <span className={scoreClass}>{score}</span>
      </div>
      <span className="body_medium_xs text-content_quaternary">
        {rankLabel}
      </span>
    </div>
  );
};
